import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const isSupabaseConfigured = Boolean(url && anonKey)
export const supabase = isSupabaseConfigured ? createClient(url, anonKey) : null

export async function signInWithNameAndPin(name: string, pin: string) {
  if (!supabase) throw new Error('Supabase가 아직 연결되지 않았어요.')

  const { data, error } = await supabase.functions.invoke('classroom-login', {
    body: { name: name.trim(), pin },
  })
  if (error || !data?.tokenHash) throw new Error(data?.message || '이름 또는 PIN을 확인해 주세요.')

  const verified = await supabase.auth.verifyOtp({
    token_hash: data.tokenHash,
    type: 'magiclink',
  })
  if (verified.error) throw verified.error
  return verified.data.session
}
